import { useEffect, useState } from 'react';
import {
  getGetAllDeviceByParameter,
  getGetAllParameterByDevice,
} from '../../api/analysis';
import { TextDeviceCotext } from './TextDeviceCotext';

function ContextDevice(props) {
  useEffect(() => {
    handleGetAllDeviceByParameter();
    handleGetAllParameterByDevice();
  }, []);

  const [allDevice, setAllDevice] = useState([]);
  const [allParameter, setAllParameter] = useState([]);
  const handleGetAllDeviceByParameter = async () => {
    try {
      const { data } = await getGetAllDeviceByParameter();
      const devices = JSON.parse(data.result);
      setAllDevice(devices);
    } catch (err) {
      console.log(err);
    }
  };
  const handleGetAllParameterByDevice = async () => {
    try {
      const { data } = await getGetAllParameterByDevice();
      const parameters = JSON.parse(data.result);
      setAllParameter(parameters);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <TextDeviceCotext.Provider
      value={{
        allDevice,
        allParameter,
        refresh_ContextDevice: handleGetAllDeviceByParameter,
      }}
    >
      {props.children}
    </TextDeviceCotext.Provider>
  );
}

export default ContextDevice;
